<div class="header">
  <div class="logo" routerLink="/"></div>
  <div class="btns-block">
    <div class="menu">
      <ul>
        <li (click)="goToSupport()">Support</li>
        <li (click)="goToLogin()">Login</li>
      </ul>
    </div>
    <button class="demo" (click)="goToContact()">Request demo</button>
  </div>
</div>
